export function selectQueryParamChannel(
  uuidParam,
  allChannels,
  updateCurrentChannelUrl,
  updateCurrentChannelMembers,
  changeToChannelPanel,
  updateChannelNotFound,
  sendSegmentEvent
) {
  if (!uuidParam) {
    return;
  }
  let channelFound = false;
  allChannels.every((channel) => {
    channel.members.forEach((member) => {
      if (member.userId === uuidParam) channelFound = true;
    });
    if (channelFound) {
      updateCurrentChannelUrl(channel.url);
      updateCurrentChannelMembers(channel.members);
      changeToChannelPanel();

      return false;
    }
    return true;
  });
  // if we don't find the channel & they have been loaded, show message to user
  if (!channelFound && allChannels.length) {
    updateChannelNotFound();
    changeToChannelPanel();
    sendSegmentEvent('Invalid Messaging Link', { uuid_param: uuidParam });
  }
}

export function getOrRefreshToken(readDomainCookie, accountId, getToken, setToken) {
  // see if the user has a token already
  const sendbirdToken = readDomainCookie(`user_${accountId}_sendbird_token`);
  if (!sendbirdToken) {
    getToken();
  } else {
    // check if it's expired, refresh if it is
    const parsedToken = JSON.parse(sendbirdToken);
    const expiryDate = new Date(parsedToken.expiresAt);
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    if (expiryDate < tomorrow) {
      // token is expired or expiring within 24 hours - get a new one
      getToken();
    } else {
      setToken(parsedToken.token);
    }
  }
}
